// Personal Information Configuration
// Update this file to change personal details across the site

export const personalInfo = {
  name: "Tushar Singh",
  title: "Full-Stack Developer",
  tagline: "Turning ideas into reality through code. 12+ years of building apps, solving problems, and crafting digital experiences that people actually enjoy using.",
  profileImage: "/assets/img/profilepicture.png",
  
  // Social Links
  social: {
    email: "tusharsingh44@gmail.com",
    github: "https://github.com/tusharsingh1991",
    linkedin: "https://www.linkedin.com/in/tusharsingh1991/",
    twitter: "https://x.com/tusharsingh1991",
    medium: "https://medium.com/@tusharsingh1991"
  },
  
  // Contact Information
  contact: {
    email: "tusharsingh44@gmail.com",
    phone: "Available on request",
    location: "Noida, India"
  },
  
  // Hero Tags
  tags: [
    "Full-Stack Developer",
    "React Native Expert",
    "Web3 Explorer",
    "Coffee Addict"
  ],
  
  // About Highlights
  highlights: [
    {
      title: "12+ Years Experience",
      description: "From Android apps to full-stack web applications, I've built solutions that millions use daily"
    },
    {
      title: "Tech Explorer",
      description: "Diving deep into blockchain, cloud architecture, and modern frameworks. Always learning, always building."
    },
    {
      title: "Problem Solver",
      description: "I don't just write code—I solve real problems and create experiences people love"
    }
  ],
  
  // About Description
  about: {
    intro: "Hey there! I'm Tushar, a software engineer who's been playing with code for over 12 years now. What started as building Android apps back in 2013 has turned into a journey through full-stack development, leading teams, and architecting systems that actually work at scale.",
    journey: "I've worked across the entire tech spectrum - from mobile apps with millions of users to fintech platforms handling serious money, to real-time systems serving thousands of concurrent users. These days, I'm leading projects at R Systems, where I get to architect solutions, mentor developers, and occasionally break things in production (just kidding... mostly).",
    passion: "What really gets me excited? Building things that matter. Whether it's optimizing a database query that saves seconds for millions of users, architecting a payment system that just works, or mentoring a junior dev through their first production deploy - I love the craft of software engineering.",
    tech: "I live in the JavaScript/TypeScript world these days - React, React Native, Node.js - but I've got battle scars from Java, Python, and plenty of others. I'm also exploring Web3 because, well, who isn't curious about blockchain?",
    philosophy: "My philosophy is simple: write code that your future self won't curse at, document like your life depends on it, and never stop learning. Oh, and always have a good cup of coffee nearby."
  },
  
  // Resume Link
  resumePath: "/assets/tusharsingh.pdf"
};

export default personalInfo;
